/**
 *
 * Ask
 *
 */

import { QaTagsModelMixin } from './model';

import QaTags from '@/components/QA/Tags.vue';

export const QaTagsMixin = {
  name: 'QaTagsMixin',

  mixins: [QaTagsModelMixin],

  components: {
    'qa-tags': QaTags,
  },

  data: () => {
    return {};
  },

  computed: {
    c_isSelectedTag() {
      return this.mg_isSelectedTag;
    },

    _c_selectedTag() {
      return this.mg_selectedTag;
    },

    c_isSelectedTagDisabled() {
      return (
        this._c_selectedTag.qaChanceLimit &&
        0 === this._c_selectedTag.askingChances &&
        this._c_selectedTag.pointsPerQuestion > this._c_selectedTag.bonusPoint
      );
    },

    c_selectedTag() {
      return {
        ...this._c_selectedTag,
        c_isSelectedTagDisabled: this.c_isSelectedTagDisabled,
      };
    },

    c_isNeedSubTag() {
      return this.mg_isNeedSubTag;
    },

    c_isSelectedSubTag() {
      return this.mg_isSelectedSubTag;
    },

    c_isSelectedTagsReady() {
      return (
        this.c_isSelectedTag &&
        !this.c_isSelectedTagDisabled &&
        (!this.c_isNeedSubTag || this.c_isSelectedSubTag)
      );
    },

    c_selectedTagId() {
      return this.ms_selectedTagId;
    },

    c_selectedSubTagId() {
      return this.ms_selectedSubTagId;
    },

    c_selectedTagsId() {
      let selectedTagsId = [];
      if (this.c_isSelectedTag) {
        selectedTagsId = [...selectedTagsId, this.c_selectedTagId];
        if (this.c_isSelectedSubTag) {
          selectedTagsId = [...selectedTagsId, this.c_selectedSubTagId];
        }
      }
      return selectedTagsId;
    },
  },

  methods: {
    clearSelectedTag() {
      this.mm_SET_SELECTED_TAG_ID(-1);
      this.mm_SET_SELECTED_SUBTAG_ID(-1);
    },
  },
};

export default QaTagsMixin;
